<template>
  <div class="phonesubmit">
    <z-fix-top
      keep-position
      class="fixtop"
      :style="{background: '#F7F7F7'}"
    >
      <z-nav-bar
          class="navbar"
          left-arrow
          title="举报凭证"
          @click-left="handleClickLeft"
      >
      </z-nav-bar>
    </z-fix-top>
    <z-notice-bar
      text="举证将占用您3~5分钟，填写越仔细，举报成功概率更高"
      left-icon="https://dl.zhuanstatic.com/fecommon/公告小喇叭.svg"
    />
    <div class="content">
      <EvidenceBlock
        v-for="(item) in choosedIndexs"
        :max="5"
        :key="item"
        :evidenceData="examples[item]"
        :Finished="(data) => Finished(data,item)"
        :cache="cache[item]"
        >
      </EvidenceBlock>
      <SelectRadio :cache="outsideCache" :Finished="outerFinish" :radioData="radioData2"></SelectRadio>
    </div>
    <z-button-group>
      <z-button class="savelocal" @click="setLocal">存草稿</z-button>
      <z-button :loading="sharedData.globalLoading" type="primary" @click="submit" :disabled="!canSubmit">提交</z-button>
    </z-button-group>
  </div>
</template>

<script>
import { Button, ButtonGroup, NoticeBar, Dialog, FixTop, NavBar } from '@zz-common/zz-ui'
import EvidenceBlock from '../../components/EvidenceBlock'
import SelectRadio from '../../components/SelectRadio'
import { newReportGetExample } from '@api/resourceApi'
export default {
  name: 'PhoneSubmit',
  components: {
    zButton: Button,
    zButtonGroup: ButtonGroup,
    EvidenceBlock,
    SelectRadio,
    'z-notice-bar': NoticeBar,
    'z-fix-top': FixTop,
    'z-nav-bar': NavBar
  },
  inject: ['sharedData', 'mergeSubmitData', 'globalSubmit', 'submitData', 'files2PicAndVideo', 'setNavTitle'],
  data() {
    return {
      pics: [], //凭证照片和视频
      content: [], //凭证描述 多个用逗号分割
      outsideCommunication: '', // 是否有站外沟通 0没有 1有  不选传null
      outsidePic: [], //站外沟通凭证照片
      examples: [],
      choosedIndexs: [], //里面存的是index
      cache: {}, //每一项的内容缓存
      outsideCache: {
        files: [],
        evidence: ''
      }, //站外凭证缓存
      radioData2: {
        question: '您与对方是否有平台外沟通',
        answer: [
          {
            id: 0,
            desc: '否'
          },
          {
            id: 1,
            desc: '是',
            outer: true
          }
        ]
      }
    }
  },
  created() {
    console.log('看看localstorage', localStorage.getItem('phonesubmit'))
    let cacheData = null
    try {
      cacheData = JSON.parse(localStorage.getItem('phonesubmit'))
    } catch {
      cacheData = null
    }
    //30天
    if (cacheData && Date.now() - cacheData.date < 2592000000) {
      this.cache = cacheData.cache
      this.outsideCache = cacheData.outsideCache
    }
    newReportGetExample().then(res => {
      this.examples = res
      console.log('看看examples', this.examples)
    })
  },
  watch: {
    $route: {
      handler(to, _from) {
        if (to.query.choosedIndexs) {
          this.choosedIndexs = to.query.choosedIndexs.sort()
        }
        console.log('看看chosedIndexs', this.choosedIndexs)
      },
      immediate: true
    }
  },
  computed: {
    canSubmit() {
      if (this.sharedData.evidenceLoading) return false
      if (this.outsideCommunication === 0) {
        return this.choosedIndexs.every(item => !!this.cache[item]) &&
          Object.values(this.calcSubmitData).every(item => item.message.length >= 5) &&
          Object.values(this.calcSubmitData).every(item => item.files.length > 0)
      }
      if (this.outsideCommunication === 1) {
        return this.choosedIndexs.every(item => !!this.cache[item]) &&
          Object.values(this.calcSubmitData).every(item => item.message.length >= 5) &&
          Object.values(this.calcSubmitData).every(item => item.files.length > 0) &&
          this.outsidePic.length > 0
      }
      return false
    },
    calcSubmitData() {
      const data = {}
      this.choosedIndexs.forEach(item => {
        if (this.cache[item]) {
          data[item] = this.cache[item]
        }
      })
      return data
    }
  },
  methods: {
    Finished(data, index) {
      this.$set(this.cache, index, data)
    },
    submit() {
      this.pics = []
      this.content = []
      Object.values(this.calcSubmitData).forEach(item => {
        this.pics.push(...this.files2PicAndVideo(item.files))
        this.content.push(item.message)
      })
      this.mergeSubmitData({
        pics: JSON.stringify(this.pics),
        content: this.content.join(','),
        outsideCommunication: this.outsideCommunication,
        outsidePic: JSON.stringify(this.outsidePic)
      })
      this.globalSubmit(this.submitData, true)
    },
    setLocal() {
      const data = {
        date: Date.now(),
        cache: this.cache,
        outsideCache: this.outsideCache
      }
      localStorage.setItem('phonesubmit', JSON.stringify(data))
      this.$toast('保存成功')
    },
    outerFinish(data) {
      this.outsideCommunication = data.evidence
      this.outsidePic = data.outerUpload.map(t => t.url)
      this.outsideCache.evidence = data.evidence
      this.outsideCache.files = data.outerUpload
    },
    handleClickLeft() {
      Dialog({
        message: '您当前编辑未完成，是否保存到草稿箱？',
        closeOnClickOverlay: false,
        showCancelButton: true
      }).then(() => {
        this.setLocal()
        this.$router.back()
      }).catch(_type => {
        this.$router.back()
      });
    }
  }
}
</script>

<style lang="less" scoped>
@import "index.less";
</style>